import { firebaseEnvironment } from "@repo/common";
import { AuthProvider } from "@repo/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { RefreshVersionBanner } from "./components/RefreshVersionBanner";
import "./index.css";
import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: "https://1ba4d92b8bdbc025bba3e23a317dd210@o4510454344581120.ingest.us.sentry.io/4510519048339456",
	environment: firebaseEnvironment,
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
});

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<AuthProvider>
			<App />
			<RefreshVersionBanner />
		</AuthProvider>
	</StrictMode>,
);
